<template>


  <div class="animated fadeIn">


    <b-row>
      <b-col md="12">
        <b-card>

          <b-col md="8" style="margin-left: auto;margin-right: auto;">
                   <b-card-group>
                     <b-card>
                       <b-card-body>
                    <h1>Terms</h1>
                      <h1>Data Policy</h1>
                        <h1>Cookies Policy</h1>
                       </b-card-body>
                     </b-card>


                   </b-card-group>
                 </b-col>

        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import { Callout } from '@coreui/vue'

export default {
  name: 'dashboard',
  components: {
    Callout,

  },
  data: function () {
    return {
      selected: 'Month',
      type:'',
      // Must be an array reference!
      show: true,
      save: false,
      firstName: '',
      lastName: '',
      username: '',
      disabled: 0,
      companyName: '',
      saveStatus: 'Submit',
      status: '',
      type: '',
      address1:'',
      address2:'',
      city:'',
      state:'',
      zip:'',
      phone:'',
      fax:'',
      website:'',
      year:'',
      enabled: false,
      value: false,
      stateList:['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'District of Columbia', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'],
      tableItems: [
        {
          avatar: { url: 'img/avatars/1.jpg', status: 'success' },
          user: { name: 'Yiorgos Avraamu', new: true, registered: 'Jan 1, 2015' },
          country: { name: 'USA', flag: 'us' },
          usage: { value: 50, period: 'Jun 11, 2015 - Jul 10, 2015' },
          payment: { name: 'Mastercard', icon: 'fa fa-cc-mastercard' },
          activity: '10 sec ago'
        },
        {
          avatar: { url: 'img/avatars/2.jpg', status: 'danger' },
          user: { name: 'Avram Tarasios', new: false, registered: 'Jan 1, 2015' },
          country: { name: 'Brazil', flag: 'br' },
          usage: { value: 22, period: 'Jun 11, 2015 - Jul 10, 2015' },
          payment: { name: 'Visa', icon: 'fa fa-cc-visa' },
          activity: '5 minutes ago'
        },
        {
          avatar: { url: 'img/avatars/3.jpg', status: 'warning' },
          user: { name: 'Quintin Ed', new: true, registered: 'Jan 1, 2015' },
          country: { name: 'India', flag: 'in' },
          usage: { value: 74, period: 'Jun 11, 2015 - Jul 10, 2015' },
          payment: { name: 'Stripe', icon: 'fa fa-cc-stripe' },
          activity: '1 hour ago'
        },
        {
          avatar: { url: 'img/avatars/4.jpg', status: '' },
          user: { name: 'Enéas Kwadwo', new: true, registered: 'Jan 1, 2015' },
          country: { name: 'France', flag: 'fr' },
          usage: { value: 98, period: 'Jun 11, 2015 - Jul 10, 2015' },
          payment: { name: 'PayPal', icon: 'fa fa-paypal' },
          activity: 'Last month'
        },
        {
          avatar: { url: 'img/avatars/5.jpg', status: 'success' },
          user: { name: 'Agapetus Tadeáš', new: true, registered: 'Jan 1, 2015' },
          country: { name: 'Spain', flag: 'es' },
          usage: { value: 22, period: 'Jun 11, 2015 - Jul 10, 2015' },
          payment: { name: 'Google Wallet', icon: 'fa fa-google-wallet' },
          activity: 'Last week'
        },
        {
          avatar: { url: 'img/avatars/6.jpg', status: 'danger' },
          user: { name: 'Friderik Dávid', new: true, registered: 'Jan 1, 2015' },
          country: { name: 'Poland', flag: 'pl' },
          usage: { value: 43, period: 'Jun 11, 2015 - Jul 10, 2015' },
          payment: { name: 'Amex', icon: 'fa fa-cc-amex' },
          activity: 'Last week'
        }
      ],
      tableFields: {
        avatar: {
          label: '<i class="icon-people"></i>',
          class: 'text-center'
        },
        user: {
          label: 'User'
        },
        country: {
          label: 'Country',
          class: 'text-center'
        },
        usage: {
          label: 'Usage'
        },
        payment: {
          label: 'Payment method',
          class: 'text-center'
        },
        activity: {
          label: 'Activity'
        }
      }
    }
  },
  methods: {
    getType(){
      console.log(this.$route)
 var reportID=this.$route.fullPath.split('?')
 var reportID=reportID[1];
 this.name=reportID;
 console.log(reportID)

 if(reportID=='fab'){this.type='fabricator'}
  if(reportID=='dis'){this.type='distributor'}
    },
    onSubmit() {
      console.log('t')
        var vm = this;
        vm.disabled = (vm.disabled + 1) % 2
        vm.saveStatus = 'Connecting..'
        var data = {
            username: vm.username,
            firstName: vm.firstName,
            lastName: vm.lastName,
            companyName: vm.companyName,
            type:vm.type,
            address1:vm.address1,
            address2:vm.address2,
            city:vm.city,
            state:vm.state,
            zip:vm.zip,
            phone:vm.phone,
            fax:vm.fax,
            website:vm.website,
            year:vm.year,

        }

        this.$http.post('/addUser', data, {
            emulateJSON: true
        }).then(function(data, err) {
            // Success

            save: true,
            console.log(data.body)
            if(data.body.status=='success'){
            vm.saveStatus = 'Success'
          window.location='/signup-note?'+vm.firstName+'';
            setTimeout(function() {
                vm.saveStatus = 'Save'
                vm.disabled = (vm.disabled + 1) % 2
            }, 2500);
}else{
vm.saveStatus = data.body.status

setTimeout(function() {
vm.saveStatus = 'Submit'

vm.disabled = (vm.disabled + 1) % 2
}, 2500);
}

        }, function(data) {
            // Error
            save: true,
            console.log(data.body)
            vm.saveStatus = 'Error, User Not Saved'
            setTimeout(function() {
                vm.saveStatus = 'Submit'
                vm.disabled = (vm.disabled + 1) % 2
            }, 2500);
        });

    },
    variant (value) {
      let $variant
      if (value <= 25) {
        $variant = 'info'
      } else if (value > 25 && value <= 50) {
        $variant = 'success'
      } else if (value > 50 && value <= 75) {
        $variant = 'warning'
      } else if (value > 75 && value <= 100) {
        $variant = 'danger'
      }
      return $variant
    },
    flag (value) {
      return 'flag-icon flag-icon-' + value
    }
  },
  mounted () {
  
  },
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }

  @media only screen and (min-width: 996px) {
.app-header .navbar-toggler{display:none}
  .sidebar {
    margin-left: -200px !important;
}
html:not([dir=rtl]) .sidebar-lg-show.sidebar-fixed .app-footer, html:not([dir=rtl]) .sidebar-lg-show.sidebar-fixed .main {
    margin-left: 0px;
}
}
.breadcrumb{
  background:#46617A;
  color:#fff;
  margin:0px;
}
.breadcrumb a{
      color: #AFEEEE;
}
.main .container-fluid {
    padding: 0;

}
.card{

    border-radius: 0;
    border: none;

}
.btn-primary:not(:disabled):not(.disabled).active, .btn-primary:not(:disabled):not(.disabled):active, .show>.btn-primary.dropdown-toggle {
    background-color: #BC8166;
    border-color: #fff;
    color: #fff;
}
.btn-primary {
  background-color: #BC8166;
  border-color: #fff;
  color: #fff;
}
</style>
